import { AddressType } from '@shopby/shop-sdk';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { getBookedAddresses } from '../../api/orderHistory';
import { slideDown, slideUp } from '../../js/animation';
import { colorObj, fontWeight } from '../color';
import { useCommonContext } from '../provider/CommonProvider';
import { ModalBackground, ModalWrap } from './orderModal';

export default function OrderRecentModal({
  setIsModal,
  setModalSelectAddress,
}: {
  setIsModal: React.Dispatch<React.SetStateAction<boolean>>;
  setModalSelectAddress: React.Dispatch<React.SetStateAction<string>>;
}) {
  const [closing, setClosing] = useState<boolean>(false); // 닫힘 애니메이션 적용에 필요
  const [item, setItem] = useState<AddressType[]>([]);
  const [recentItem, setRecentItem] = useState<AddressType[]>([]);
  const { hasAccessToken } = useCommonContext();

  const closeModal = () => {
    setClosing(true);

    setTimeout(() => {
      setIsModal(false);
      setClosing(false);
    }, 280);
  };

  useEffect(() => {
    if (hasAccessToken) {
      getBookedAddresses()
        .then((res) => {
          setItem(res.data.contents);
        })
        .catch((err) => console.log(err));
    }
  }, []);

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  const removeDuplicatesById = (array: any) => {
    const uniqueMap = new Map();
    array.forEach((item: any) => {
      if (!uniqueMap.has(item.receiverZipCd)) {
        uniqueMap.set(item.receiverZipCd, item);
      }
    });
    setRecentItem(Array.from(uniqueMap.values()));
  };

  useEffect(() => {
    if (item) {
      removeDuplicatesById(item);
    }
  }, [item]);

  // if (!isModal) return null;
  return (
    <ModalWrap>
      <ModalBox closing={closing}>
        <ModalHeader>
          <p>최근 배송지</p>
          <button onClick={closeModal} className="btn_close">
            <img src="../images/icon_close.png" alt="닫기" />
          </button>
        </ModalHeader>
        <ModalBody>
          {recentItem?.length === 0 ? (
            <NoContentWrap>
              <NoContentCotentWrap2>
                <NoContentContent
                  style={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    fontSize: '16px',
                    fontWeight: '500',
                    lineHeight: '24px',
                  }}
                >
                  <p style={{ marginBottom: '8px' }}>
                    <img src="/images/empty_logo.png" alt="" />
                  </p>
                  <p>최근 배송지 내역이 없습니다.</p>
                </NoContentContent>
              </NoContentCotentWrap2>
            </NoContentWrap>
          ) : null}
          {recentItem?.slice(0, 3)?.map((el: any, index: number) => {
            return (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  width: '100%',
                  padding: '0',
                  alignItems: 'center',
                  gap: '24px',
                }}
                key={`${index}1`}
              >
                <p
                  style={{
                    color: colorObj.colBlack,
                    fontWeight: fontWeight.medium,
                    lineHeight: '22px',
                    fontSize: '14px',
                  }}
                >
                  {`${el.receiverAddress} ${el.receiverDetailAddress}`}
                </p>
                <span
                  style={{
                    fontSize: '12px',
                    fontWeight: fontWeight.semibold,
                    lineHeight: '16px',
                    color: colorObj.colGray7,
                    padding: '4px 10px',
                    background: colorObj.colGray2,
                    borderRadius: '22.5px',
                    cursor: 'pointer',
                    whiteSpace: 'nowrap',
                  }}
                  onClick={() => {
                    setModalSelectAddress(el);
                    closeModal();
                  }}
                >
                  선택
                </span>
              </div>
            );
          })}
        </ModalBody>
      </ModalBox>
      <ModalBackground onClick={closeModal} closing={closing} style={{ position: 'fixed' }}></ModalBackground>
    </ModalWrap>
  );
}
interface typeProps {
  closing?: boolean;
}

export const ModalBox = styled.div<typeProps>`
  width: 100%;
  background-color: var(--colWhite);
  border-radius: 22px 22px 0 0;
  animation: ${({ closing }) => (closing ? slideDown : slideUp)} 0.3s ease-in-out;
  position: fixed;
  z-index: 30;
  display: flex;
  flex-direction: column;
  bottom: 0;
  padding: 0;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 18.5px 22px 0 33px;
  align-items: center;
  gap: 8px;
  & p {
    flex: 1;
    font-size: 20px;
    font-weight: 600;
    line-height: 24px;
    color: var(--colBlack);
  }
  & button.btn_close {
    width: 48px;
    height: 48px;
    padding: 12px;
    background: none;
    border: none;
    cursor: pointer;
    img {
      width: 100%;
      height: 100%;
    }
  }
`;

export const ModalBody = styled.div`
  padding: 8px 33px 32px 33px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  min-height: 220px;
`;

export const NoContentWrap = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;

  @media screen and (min-width: 768px) {
    display: flex;
    padding: 0;
    height: 100%;
    justify-content: center;
    align-items: center;
  }
`;

export const NoContentCotentWrap2 = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 48px 0;
  & img {
    width: 85px;
    height: 85px;
  }
  @media screen and (min-width: 768px) {
    & img {
      width: 108px;
      height: 108px;
    }
  }
`;

export const NoContentContent = styled.p`
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  color: var(--colGray5);
  text-align: center;
  margin-bottom: 20px;
  @media screen and (min-width: 768px) {
    font-size: 20px;
    font-weight: 500;
    line-height: 32px;
  }
`;
